import { Identifiable } from "./Identifiable";
import { APP_TITLE, SUPPORT_EMAIL } from "../config/env";


export const defaultConfiguration: Configuration = {
    id: "public",
    allowPublic: "no",
    supportEmail: SUPPORT_EMAIL,
    title: APP_TITLE,
    mission: " ",
    rules: "",
    terms: '',
    privacyPolicy: '',
    communityGuidelines: '',
    disclaimer: "",
    version: "8.1.0"
};

export interface Configuration extends Identifiable {
    allowPublic?: string;
    supportEmail: string;
    title: string;
    mission: string,
    transmitNotice?: string;
    rules: string;
    terms?: string,
    privacyPolicy?: string,
    communityGuidelines?: string,
    disclaimer: string;
    version: string,
}
